// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WF5l","textarea":"styles_textarea__1uP-5"};